module.exports = __webpack_public_path__ + "img/momeni.1cc58d0f.svg";